import { useQuery } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from "../../../forBinding";
import type { Property } from "../../types";

interface PropertiesByBoundUsersResponse {
	docs: Property[];
	totalDocs: number;
	limit: number;
	totalPages: number;
	page: number;
}

interface UseGetPropertiesByBoundUsersParams {
	bindingType: number;
	page?: number;
	limit?: number;
	enabled?: boolean;
}

export function useGetPropertiesByBoundUsers({
	bindingType,
	page = 1,
	limit = 100,
	enabled = true,
}: UseGetPropertiesByBoundUsersParams) {
	const forBinding = useForBindingId();

	const query = useQuery({
		queryKey: ["properties-by-bound-users", bindingType, forBinding, page, limit],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<PropertiesByBoundUsersResponse>(
				`/prop/findAllByBoundUsers/${bindingType}`,
				{ params: { forBinding, page, limit } }
			);
			return data;
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
	};
}
